// @flow
import * as React from "react"
import { connect } from "react-redux"
import classnames from "classnames"
import type { Params, Location, Routes } from "react-router"
import ModalsAuth from "@kiwicom/nitro/lib/components/ModalsAuth"
import styled from "styled-components"

import Notice from "common/components/Notice/Notice"
import MoveToBody from "common/components/MoveToBody/MoveToBody"
import HelpCenterWidget from "../../modules/HelpCenter/HelpCenterWidgetSync"
import * as helpCenterActions from "../../scenes/HelpCenter/services/helpCenterDuck"
import Sidebar from "../Sidebar/Sidebar"
import MobileAd from "../MobileAd/MobileAd"
import {
  isPagesPlatformPageSelector,
  isPagesInvitePageSelector,
} from "../../../content/scenes/Pages/services/pagesSelectors"
import UpdateRoute from "../UpdateRoute/UpdateRoute"
import { isKiwiBrandingSelector } from "common/services/branding/selectors"
import { isLoginOpened } from "../../services/modals/selectors"
import MaintenanceModal from "../MaintenanceModal/MaintenanceModal"
import SmartFAQ from "../../modules/SmartFAQ"
import CookiesMobile from "../CookiesMobile"
import CookiesDesktop from "../CookiesDesktop"
import NitroSideEffects from "../NitroSideEffects"
import type SearchFormState from "common/records/SearchFormState"
import { showModal } from "../../services/modals/actions"
import { getDeepLink } from "../../../../app/scripts/modules/Navbar/helpers/deeplink"

const isHelpCenter = (pageName: ?string) => (pageName ? pageName.includes("helpCenter") : false)

/**
 * OLD NAVBAR IMPL
 *
 {!props.isPagesInviteContentPage && (
   <div id="navbar">
     {" "}
    <Navbar
      simple={props.simple}
      onChangeLanguage={props.onChangeLanguage}
      searchForm={props.searchForm}
    />
    </div>
  )}
 */

const NavBar = styled.div`
  position: relative;
  z-index: 799; // Orbit modals are 800
`

type Connect = {|
  isPhoneModalOpened: boolean,
  pageName: string,
  isPagesPlatformPage: boolean,
  isPagesInviteContentPage: boolean,
  helpCenterWidgetOpened: boolean,
  loginOpened: boolean,
  maintenance: boolean,
  closeHelpCenter: () => void,
  searchForm: SearchFormState,
|}

type Props = {
  ...Connect,
  routes: Routes,
  location: Location,
  params: Params,
  children: React.Node,
  navbar: React.Node,
  query: { deeplink: string },
  showModal: (modal: string, obj: {| activeTab: string |}) => void,
  modals: Map<string, string>,
  helpCenterWidget: any, // NO IDEA
  onChangeLanguage: () => void,
  simple: boolean,
  isKiwiBranding: boolean,
}

class MainView extends React.Component<Props> {
  componentDidMount() {
    const deepLink = getDeepLink(this.props.query.deeplink)
    if (deepLink) {
      this.props.showModal("login", { activeTab: deepLink })
    }
  }

  render() {
    const { props } = this

    return (
      <UpdateRoute
        routes={props.routes}
        params={props.params}
        query={props.location ? props.location.query : {}}
      >
        <CookiesMobile />
        <NitroSideEffects />
        <ModalsAuth portal="modals" />
        <NavBar>
          <nav className="NitroNavBar">{props.navbar}</nav>
        </NavBar>
        <div
          className={classnames("MainView", {
            _pagesPlatform: props.isPagesInviteContentPage,
            loginOpened: props.loginOpened,
            _nomove: props.isPhoneModalOpened,
          })}
        >
          {props.pageName !== "booking" &&
            !props.isPagesPlatformPage &&
            !props.isPagesInviteContentPage &&
            props.isKiwiBranding && <MobileAd />}
          {props.maintenance && !isHelpCenter(props.pageName) ? (
            <MaintenanceModal />
          ) : (
            props.children
          )}
          {!props.isPagesInviteContentPage && (
            <Sidebar show={props.helpCenterWidgetOpened} onHide={props.closeHelpCenter}>
              <HelpCenterWidget />
            </Sidebar>
          )}
          {!props.isPagesInviteContentPage && <SmartFAQ />}
        </div>
        <Notice />
        <MoveToBody>
          <CookiesDesktop />
        </MoveToBody>
      </UpdateRoute>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    isPhoneModalOpened: Boolean(state.modals.get("phoneNumbers")),
    pageName: state.page.get("name"),
    isPagesPlatformPage: isPagesPlatformPageSelector(state),
    isPagesInviteContentPage: isPagesInvitePageSelector(state),
    helpCenterWidgetOpened: state.helpCenter.widget.get("open"),
    loginOpened: isLoginOpened(state),
    maintenance: Boolean(state.modals.get("maintenance")),
    query: state.query,
    isKiwiBranding: isKiwiBrandingSelector(state),
  }),
  {
    showModal,
    closeHelpCenter: helpCenterActions.closeWidget,
  },
)(MainView)
